import React from 'react';
import { useNavigate } from 'react-router-dom';
import { GenericListPage } from '../../components/generic';
import { useClients, Client } from './useData';
import { moduleConfig, getColumns, getToolbarIcon, getTableActions } from './config';

const List: React.FC = () => {
  const navigate = useNavigate();

  return (
    <GenericListPage<Client>
      useData={useClients}
      config={{
        ...moduleConfig,
        defaultTableDensity: 'compact',
        getColumns,
        getToolbarIcon,
        getTableActions,
      }}
      listContext={{
        onOpenSummary: (item: Client) => navigate(moduleConfig.module.route.summary(item.clientId)),
      }}
    />
  );
};

export default List;
